module.exports = __webpack_public_path__ + "static/2-490ffdd46134aca66418b52ccebab289.png";